import 'unpoly';

const { up } = window;

// Only log the Unpoly banner in development mode.
up.log.config.banner = (import.meta.env.MODE === 'development');

// When the back/forward buttons are used do not replace the `<body>` target
// (the default: https://unpoly.com/up.history.config#config.restoreTargets),
// and instead target the `up-main` element
// (https://unpoly.com/up.fragment.config#config.mainTargets).
//
// The reason for this is the USWDS adds event handlers on `<body>` (they use
// https://www.npmjs.com/package/receptor) so even with `up-keep`s for elements
// inside, if the root `<body>` element is replaced, then the USWDS event
// listeners disappear.
up.history.config.restoreTargets = up.fragment.config.mainTargets;

// By default, on back/forward button usage Unpoly tries to `restore` the
// previous scroll position, but this seems buggy at least when following
// anchor links that weren't part of Unpoly's own actions, so revert this to
// the `auto` behavior instead.
up.on('up:location:restore', (event) => {
  event.renderOptions.scroll = ['auto'];
});

export default up;
